import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./Checkbox.module.css";
import checkmark from "./checkmark2.png";

/**
 * Custom checkbox
 */
export function Checkbox({ checked, onChange, className, visible = true  }) {
  return (
    <div
      style={{visibility: visible ? "visible" : "hidden"}}
      className={classNames(styles.checkboxContainer, className)}
      onClick={onChange}
    >
      
        <div className={styles.checkMarkContainer}>
          {checked && (<img src={checkmark} className={styles.checkMark} />)}
        </div>
      
    </div>
  );
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};
